<template>
  <div class="pk-flex__1 pk-flex pk-page-wrapper">
    <div class="pk-page-spacing-flex"></div>
    <div class="pk-page-col-1 pk-flex--column"
     style="padding:30px;">
      <div class="col-1-body pk-flex--column">
        <img :src="getImg('ae_start.png')"
         style="height:200px">
        <div class="pk-flex__00auto pk-flex__vh-center"
         style="background-color:rgb(157,156,161); color:#fff; padding:2px 5px 8px;">Archive Editions</div>
        <div class="pk-flex__1"
         style="overflow: auto;" v-html="infoText">
        </div>
      </div>
    </div>
    <div class="pk-page-col-2 pk-flex--column"
     style="padding:30px">
      <div class="col-2-body pk-flex--column">
        <div class="pk-flex__00auto">
          <div class="pk-label--withborder" style="display:inline-block">select archive edition:</div>
        </div>
        <div class="pk-flex__1"
         style="overflow: auto">
          <img v-if="!editionList || editionList.length===0"
           src="../../assets/icons/loading.gif">
          <div v-if="editionList && editionList.length>0"
           v-for="(it,i) of editionList" :key="'e'+i"
           style="margin:10px 0px; background-color:rgb(228,228,228);padding:5px">
            <router-link :to="{path:'/ae/'+it._id+'?view=ss'}">{{ getSetTitle(it) }}</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="pk-page-col-3 pk-flex--column"
     style="padding:30px">
      <div class="col-3-body">
              <div class="pk-label--withborder">sort list by:
          </div>
        <div style="margin:10px 0px">
          <select v-model="sortAZ">
            <option value="1">Title A-Z</option>
            <option value="0">Title Z-A</option>
          </select>
        </div>
        <!--<div style="margin:10px 0px">
          <select>
            <option>producer</option>
          </select>
        </div>
        <div style="margin:10px 0px">
          <select>
            <option>none</option>
          </select>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { FudapiService } from '../../utils/fudapi.service';
import Util from '../../utils/util';

export default Vue.extend({
  data() {
    return {
      startLoad: {
        deepestReached: false,
        threads: []
      },
      sortAZ: '1',
      infoText: ''
    };
  },
  created() {
    this.$store.dispatch('fetchAllArchiveEditions');
  },
  mounted() {
    if (this.$matomo) {
      this.$matomo.trackPageView('Archive Editions');
    }
    Util.checkStartLoad({
      loadingCount: 0,
      startLoad: this.startLoad,
      retryCondition: () => { 
        return !this.$store.state.frontText || this.$store.state.frontText.length <= 0;
      },
      allDoneCallback: () => {
        const ftList = this.$store.state.frontText;
        for (const ft of ftList) {
          if (ft.key === 'Archive Editions Info') {
            const obj = {str: ft.text};
            this.startLoad.threads.push(FudapiService.transformFreetext(obj).subscribe(
              () => null,
              err => {
                console.log(err);
              },
              () => {
                const sectionList = obj.str.split('<br>');
                let str = '';
                for (const s of sectionList) {
                  if (s) {
                    str += '<section>' + s + '</section>';
                  }
                }
                this.infoText = str;
              }
            ));
          }
        }
      }
    });
  },
  destroyed() {
    for (const subscriber of this.startLoad.threads) {
      subscriber.unsubscribe();
    }
  },
  computed: {
    archiveEditions() {
      return this.$store.state.archiveEditions;
    },
    editionList() {
      const sortAZ = this.sortAZ;
      return this.archiveEditions.sort((a, b) => {
        const ta = a.doc._source['54_ssmaintitle'];
        const tb = b.doc._source['54_ssmaintitle'];
        if (ta === tb) {
          return 0;
        }

        if (sortAZ === '1') {
          return ta > tb;
        } else {
          return tb > ta;
        }
      });
    }
  },
  methods: {
    getImg(name) {
      return this.$getIcon(name);
    },
    getSetTitle(item) {
      return item.toShowTitle;
    }
  }
});
</script>

<style lang="scss"
 scoped>

.pk-page-col-1 {
  flex: 0 0 25%;
  min-width: 350px;
  .col-1-body {
    border: 2px solid rgb(202, 202, 200);
    background-color: rgb(240, 240, 240);
  }
}

.pk-page-col-2 {
  flex: 1;
}

.pk-page-col-3 {
  flex: 0 0 22%;
  min-width: 300px;
  .col-3-body {
    padding-right: 50px;
    select {
      width: 100%;
      font-size: 12px;
      border-radius: 4px;
      border: 1px solid rgb(176, 196, 229);
      padding: 2px;
    }
  }
}
</style>